import EditQuestionModal from './EditQuestionModal'

export default EditQuestionModal;